import { Flex } from 'antd';
import styled from 'styled-components';

export const StyledLegend = styled(Flex)`
  justify-content: center;
  gap: 8px;
`;
